import { SECONDARY_MENU_ACTION_TYPES } from './actionTypes';

const initialState = {
    items: [],
    loading: false,
    error: null,
    lastUpdated: null,
};

export const secondaryMenuReducer = (state = initialState, action) => {
    switch (action.type) {
        case SECONDARY_MENU_ACTION_TYPES.FETCH_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case SECONDARY_MENU_ACTION_TYPES.FETCH_SUCCESS:
            return {
                ...state,
                items: action.payload,
                loading: false,
                error: null,
                lastUpdated: action.meta.timestamp,
            };
        case SECONDARY_MENU_ACTION_TYPES.FETCH_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};
